import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule, routingComponents } from './app-routing.module';
import { AppComponent } from './app.component';
import { CustomDatePipe } from './shared/custom.datepipe';
import { UnsubsuccessComponent } from './unsubsuccess/unsubsuccess.component';
import { ErrorComponent } from './error/error.component';
import { SuccessComponent } from './success/success.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { SmsunsubComponent } from './smsunsub/smsunsub.component';
import { SuccessunsubsmsComponent } from './successunsubsms/successunsubsms.component';
import { CancelserviceComponent } from './cancelservice/cancelservice.component';
import { UnsubscribeComponent } from './unsubscribe/unsubscribe.component';

@NgModule({
  declarations: [
    /**//*
    AppComponent,
    routingComponents,
    CustomDatePipe,
    UnsubsuccessComponent,
    ErrorComponent,
    SuccessComponent,
    NotFoundComponent,
    SmsunsubComponent,
    SuccessunsubsmsComponent,
    CancelserviceComponent,
    UnsubscribeComponent
    /**/
  ],
  imports: [
    AppComponent,
    routingComponents,
    CustomDatePipe,
    UnsubsuccessComponent,
    ErrorComponent,
    SuccessComponent,
    NotFoundComponent,
    SmsunsubComponent,
    SuccessunsubsmsComponent,
    CancelserviceComponent,
    UnsubscribeComponent,

    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
